/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import User_Icon from "../icons/User_Icon";

const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipContent = styled.span`
  visibility: ${(props) => (props.show ? "visible" : "hidden")};
  position: absolute;
  background-color: #f9f9f9;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  color: #333;
  padding: 10px;
  border-radius: 5px;
  top: 100%;
  left: 300%;
  transform: translateX(-50%);
  transition: visibility 0.3s ease-in-out;
  white-space: pre-line;
`;

const TooltipIcon = styled.span`
  cursor: pointer;
`;

const InfoToolTip = ({ content }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef(null);

  const handleClick = () => {
    setShowTooltip(!showTooltip);
  };

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
        setShowTooltip(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <TooltipContainer
      style={{
        backgroundColor: "#004990",
        border: "none",
        padding: "10px",
        borderRadius: "5px",
        cursor: "pointer",
      }}
      ref={tooltipRef}
    >
      <TooltipIcon onClick={handleClick}>
        <User_Icon color={"#ffffff"} />
      </TooltipIcon>
      <TooltipContent show={showTooltip}>{content}</TooltipContent>
    </TooltipContainer>
  );
};

export default InfoToolTip;
